import React from "react";
import PressReleaseSection from "../../components/Media/PressRelease.tsx";
import MetaComponent from "../../components/CommonComponents/MetaComponent.tsx";
// import PartnerWithAptechSection from "../components/PartnerWithAptech/PartnerWithAptech.tsx";
const PressRelease = () => {
  return (
    <>
      <MetaComponent
        title="Latest Press Releases & Corporate News Updates | Official Announcements | Aptech Limited"
        desc="Stay informed with Aptech Limited’s latest press releases, corporate announcements, and news updates across the global education and training sector."
        keywords="Aptech press release, Aptech News and press release, Aptech shareholders."
      />
      <PressReleaseSection />
    </>
  );
};

export default PressRelease;
